import AIAvatarImage from '@/assets/images/ai_avatar.png'
import AIAvatarSpriteImageRaw from '@/assets/images/ai_avatar_sprite.webp'
import { cn } from '@/lib/cn'
import { useEffect, useRef } from 'react'
import { Image } from 'react-native'

import classes from './AIAvatar.web.module.css'

const AIAvatarSpriteImage = AIAvatarSpriteImageRaw as unknown as { uri: string }

type AIAvatarProps = {
  className?: string
  active?: boolean
  style?: React.CSSProperties
}

const TOTAL_FRAMES = 450
const FRAMES_PER_ROW = 20
const PLAYING_FRAME_RATE = 27

export default function AIAvatar({ className, active, style }: AIAvatarProps) {
  const avatarVideoRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = avatarVideoRef.current
    if (!el) return

    el.style.setProperty('--frame-size', getComputedStyle(el).width)

    if (!active) {
      el.style.setProperty('--row', '0')
      el.style.setProperty('--col', '0')
      return
    }

    let startT = 0
    const handleRaf = (t: number) => {
      if (!startT) startT = t
      const delta = t - startT
      const frame = Math.floor((delta / 1000) * PLAYING_FRAME_RATE)

      if (frame >= TOTAL_FRAMES) {
        startT = t
      } else {
        const row = Math.floor(frame / FRAMES_PER_ROW)
        const col = frame % FRAMES_PER_ROW

        el.style.setProperty('--row', `${row}`)
        el.style.setProperty('--col', `${col}`)
      }

      rafId = requestAnimationFrame(handleRaf)
    }

    let rafId = requestAnimationFrame(handleRaf)
    return () => {
      cancelAnimationFrame(rafId)
    }
  }, [active])

  return (
    <div className={cn(classes.wrapper, className)} style={style}>
      <Image
        source={AIAvatarImage}
        alt="AI Avatar"
        style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}
      />
      <div
        ref={avatarVideoRef}
        className={classes.avatarVideo}
        style={{ display: active ? 'block' : 'none', backgroundImage: `url(${AIAvatarSpriteImage.uri})` }}
      />
    </div>
  )
}
